/**
 * Sweep accumulated protocol fees (permissionless)
 */
import type { Address, Hash, WalletClient } from "viem"
import { breakoutMarketAbi } from "../../abi/generated/breakoutMarket"
import { getAccount } from "../../internal/contracts"

export interface SweepProtocolFeesParams {
	market: Address
}

/**
 * Sweep accumulated protocol fees to the treasury
 *
 * Can be called by anyone. Fees are sent to the treasury address
 * configured in the BreakoutRegistry.
 *
 * @example
 * ```ts
 * import { sweepProtocolFees } from "@breakout/sdk/actions/write"
 *
 * const txHash = await sweepProtocolFees(walletClient, { market: "0x..." })
 * ```
 */
export async function sweepProtocolFees(
	client: WalletClient,
	params: SweepProtocolFeesParams,
): Promise<Hash> {
	const account = await getAccount(client)

	return client.writeContract({
		address: params.market,
		abi: breakoutMarketAbi,
		functionName: "sweepProtocolFees",
		args: [],
		account,
		chain: client.chain,
	})
}
